
import React from "react"

import "./footer.scss"
const Footer = () => (
    <>
        <div className="footer media">
            kimhyoungnams@gmail.com
       </div>
    </>
)
export default Footer;